import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { getClaimsDirectUrl } from 'wmic-portals-url-js';

export default class ClaimDocumentService {
    static getClaimDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getClaimsDirectUrl('claimDownloadDocument'), documentID, token);
    }
}
